const stDesk = {
  containBttDefault: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 'auto',
    padding: 'var(--padding-mid)',
    border: '1px solid var(--color-border-gray)',
    borderRadius: 'var(--border-radius-mid)',

    '&:hover': {
      border: '1px solid var(--color-border-gray)',
    },
  },

  containLabels: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    height: 'auto',
    width: '100%',
  },
  textTitle: {
    fontFamily: 'var(--font-jost-light)',
    fontSize: 'var(--text-size-h5)',
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
    color: 'var(--color-text-pri)',
  },
  textLabel: {
    fontFamily: 'var(--font-jost-light)',
    fontSize: 'var(--text-size-h5)',
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
  },
  imgIcon: {
    width: '30px',
    height: '30px',
    marginRight: 'var(--margin-mid)',
  },
  iconLeft: {
    marginRight: 'var(--margin-mid)',
  },
  disabledButton: {
    opacity: 0.5,
    pointerEvents: 'none',
  },
  iconDefault: {},
  iconChecked: {},
}

export default stDesk
